import { render, staticRenderFns } from "./NewUpCaveat.vue?vue&type=template&id=dece7482"
import script from "./NewUpCaveat.vue?vue&type=script&lang=js"
export * from "./NewUpCaveat.vue?vue&type=script&lang=js"
import style0 from "./NewUpCaveat.vue?vue&type=style&index=0&id=dece7482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports